import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=c5b5eb12&scoped=true&"
var script = {}
import style0 from "./Projects.vue?vue&type=style&index=0&id=c5b5eb12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b5eb12",
  null
  
)

component.options.__file = "Projects.vue"
export default component.exports